import React, {Component} from 'react'
import {observer} from 'mobx-react'
import store from 'store'
import {clearSession} from 'util/admin-session'
import {logout} from 'util/admin-session-api'
import {MenuAnchor, MenuDivider, Menu, MenuItem} from 'react-mdc-web/Menu'
require('./top.css')

const TITLES = {
  '/': '运营工作台',
  '/material/home': '首页音频',
  '/material/home/add': '编辑首页音频',
  '/material/faq': '常见问题',
  '/material/faq/add': '编辑常见问题',
  '/tools/card-batch': '录音卡生产',
  '/tools/card-assets': '音频与音信卡',
  '/users/admin': '管理员审批',
  '/users': '全部用户'
}

function currentTitle() {
  let url = store.page ? store.page.url.replace(/\?.*$/, '') : '/'
  return TITLES[url] || '后台页面'
}

@observer
export default class Header extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false
    }
  }
  componentWillUnmount() {
    if (this.dropdown) {
      this.dropdown.unbind()
    }
  }
  logOut() {
    logout().catch(() => {}).then(() => {
      clearSession()
      store.setUser(null)
    })
  }
  render() {
    let {user} = store
    let {open} = this.state
    return (
      <header>
        <div class="topbar">
          <div class="topbar-brand">
            <span class="brand-mark"></span>
            <div>
              <strong>音信后台</strong>
              <small>VoiceMSG Admin</small>
            </div>
          </div>
          <div class="topbar-main">
            <div class="topbar-context">
              <span>当前任务</span>
              <strong>{currentTitle()}</strong>
            </div>
            <div class="topbar-status">
              <span class="status-dot"></span>
              <span>后台会话</span>
              <strong>已认证</strong>
            </div>
            <div class="topbar-account">
              {user.avatarUrl
                ? <img class="thumb" src={user.avatarUrl} alt={user.username} />
                : <span class="thumb thumb-fallback">{(user.username || '音').slice(0, 1)}</span>
              }
              <MenuAnchor>
                <Menu
                  open={open}
                  onClose={() => {
                    this.setState({open: false})
                  }}
                >
                  <MenuDivider></MenuDivider>
                  <MenuItem onClick={this.logOut}>退出</MenuItem>
                </Menu>
              </MenuAnchor>
              <button class="top-user name" onClick={() => {
                this.setState({open: true})
              }}>
                {user.username}
                <span class="dropdown-caret"></span>
              </button>
            </div>
          </div>
        </div>
      </header>
    )
  }
}
